import { Injectable, EventEmitter } from '@angular/core';
import {MessageDefinitionService} from "../../../../../services/messages.service";
import {Settings} from "../../../../../services/settings";
import {DwUtils} from "../../../../../components/utils/dw-utils";
import {MessageDefinition} from "../../../../../models/message-definition";
import {MailOption} from "../../../../../models/mail-option";
import {MessagesSent} from "../../../../../models/messages-sent";
import {ServiceDefService} from "../../../../../services/servicedef.service";
import {ServiceDef} from "../../../../../models/service-def";
import { MessageSuffix } from 'src/app/models/message-suffix';
import { forkJoin, of } from 'rxjs';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';

@Injectable({
    providedIn: 'root'
})
export class NewMessageHelper {

    public case: any;

    public serviceRequest: any;
    public serviceDefinition: any;
    public messageSuffix: MessageSuffix;
    public agency: any;
    public messagesService: MessageDefinitionService;
    public messageTokens: any;
    public evCode: string = '';
    public autoMessageDefinition: any;
    public autoEventMessageFlag = false;
    public statusReasonsList: any;
    
    messageSentSuccessEv: EventEmitter<any> = new EventEmitter<any>();
    messageSentFailureEv: EventEmitter<any> = new EventEmitter<any>();    

    constructor(messagesService:MessageDefinitionService, public serviceDefService:ServiceDefService, private serviceRequestsService: ServiceRequestsService, agencyId: number) {
        this.messagesService = messagesService;

        this.agency = Settings.getInstance().agencyList.find(s => s.id === agencyId);
        this.queryRecords();
    }

    public setRecords(caseParam:any, serviceRequest:any, autoEventFlag= false) :void{
        this.case = caseParam;
        this.serviceRequest = serviceRequest;
        this.autoEventMessageFlag = autoEventFlag;

		this.queryServiceDefinition(this.serviceRequest.serviceDefId || -1);
        /*
        if(this.serviceRequest.serviceDefId > 0) {
            
        } else if(this.autoEventMessageFlag === true) {
        	this.autoSendMessageByEvent(this.evCode);
        }
        */
    }
    public queryServiceDefinition(id:number):void {
		this.messageSuffix = null;
		forkJoin([(id != -1 ? this.serviceDefService.getServiceDefById(id) : of(undefined)),
				(this.serviceRequest && this.serviceRequest.requestStatusId ? this.messagesService.getMessageSuffixByServiceDefIdAndRequestStatusId(id, this.serviceRequest.requestStatusId) : of(undefined)),
				this.serviceRequestsService.getAllActiveStatusReasons()
					]).subscribe(
							(result: any[]) => {
								if(result && result.length > 0) {
									this.serviceDefinition = result[0];
								}
								if(result && result.length > 1) {
									this.messageSuffix = result[1];
								}
								if(result && result.length > 2) {
									this.statusReasonsList = result[2];
								}
								if(this.autoEventMessageFlag === true) {
				                    this.autoSendMessageByEvent(this.evCode);
				                }
							},
							(error) => {
								Settings.getInstance().handleError(error, 'fetching service definition record.')
            					this.messageSentFailureEv.emit();
							}
		);
    }

    public queryRecords():void {

        this.messageTokens = [];
        this.messagesService.getAllMessageTokens().subscribe(
            (result) => {
                if(result !== null) {
                    this.messageTokens = result;
                }
            },
            (error) => {
                Settings.getInstance().handleError(error, 'fetching message tokens');
                this.messageSentFailureEv.emit();
            }
        );
    }
    public removeNull(inp:string) : string {
        if(inp === undefined) {
            return '';
        }

        if(inp === 'null') {
            return '';
        }
        return inp;
    }
    public parseMessageBody(msgBodyTemplateText: string): string {

        /** loop through the tokens and replace (if found values in the string **/
        let tempMsg = '';

        if(this.serviceDefinition === undefined) {
            this.serviceDefinition = new ServiceDef();
        }
        for(const rec of this.messageTokens) {

            const stringValues = rec.columnValue.split('.');

            let table: string = '';
            let column: string = '';
            const tokenSearchFor: string = rec.token;
            let replaceWith: string = '';

            /** do we have a table and a column? **/
            if(stringValues.length > 1) {
                table = stringValues[0];
                column =  stringValues[1];

                if(table.toLowerCase() === 'cases' && this.case) {
                    replaceWith = this.removeNull(this.case[column]);
                }
                if(table.toLowerCase() === 'servicerequests' && this.serviceRequest) {
                    replaceWith = this.removeNull(this.serviceRequest[column]);
                }
                if(table.toLowerCase() === 'agencies' && this.agency) {
                    replaceWith = this.removeNull(this.agency[column]);
                }
                if(table.toLowerCase() === 'servicedefinition' && this.serviceDefinition) {
                    replaceWith = this.removeNull(this.serviceDefinition[column]);
                }
                if(table.toLowerCase() === 'servicerequesttypes' && this.serviceRequest) {
                    const typeId = this.serviceRequest.serviceRequestTypeId || this.serviceDefinition?.serviceRequestTypeId;
                    if (column === 'description') {
                        replaceWith = this.removeNull(Settings.getInstance().getServiceRequestTypeDesc(typeId) || '');
                    }
                }
                if(table.toLowerCase() === 'requeststatuses' && column == 'shortDescription' && this.serviceRequest) {
                    replaceWith = this.removeNull(Settings.getInstance().getRequestStatusDesc(this.serviceRequest.requestStatusId));
                }
                if(table.toLowerCase() === 'statusreasons' && column == 'description' && this.statusReasonsList && this.serviceRequest) {
					const statusReason = this.statusReasonsList.find(rec => rec.id == this.serviceRequest.statusReasonId)
                    if(statusReason)
                    	replaceWith = this.removeNull(statusReason.description);
                    else
                    	replaceWith = '';
                }
            }
            else if(stringValues.length == 1) {

                /** it is something more static **/
                if(stringValues[0] === 'dueDate' && this.serviceRequest) {
                    replaceWith = DwUtils.formatReadableDate(new Date(this.serviceRequest.dueDate));
                }

                if(stringValues[0] === 'daysLeft' && this.serviceRequest) {
                    replaceWith = DwUtils.calculateDaysLeft(new Date(this.serviceRequest.dueDate), new Date(this.serviceRequest.dateCreated)).toString();
                }
                if(stringValues[0] === 'date') {
                    replaceWith = DwUtils.formatReadableDate(new Date());
                }

                if(stringValues[0] === 'date_time') {
                    replaceWith = DwUtils.formatDTFromDate(new Date());
                }

                if(stringValues[0] === 'time') {
                    replaceWith = DwUtils.formatReadableTime(new Date());
                }
            }

            tempMsg = msgBodyTemplateText.replaceAll(tokenSearchFor, replaceWith);
            msgBodyTemplateText = tempMsg;
        }

        return tempMsg;
    }
    public autoSendMessageByEvent(evCode: string):void {

        this.autoMessageDefinition = new MessageDefinition();
        this.messagesService.getMessageDefinitionByEventCode(evCode).subscribe(

            (result)=> {
				if(result) {
	                this.autoMessageDefinition = result;
	                if(this.autoMessageDefinition.id > 0) {
	                    this.autoSetAndSendMessage();
	                }
	        	} else {
					this.messageSentFailureEv.emit("NO_MESSAGE_DEF");
				}
            },
            (error) => {
                Settings.getInstance().handleError(error, "fetching automated message");
                this.messageSentFailureEv.emit();
            });
    }
    public autoSetAndSendMessage(): void {

        let mailOpt: MailOption = new MailOption();
        let mailBody: string = this.autoMessageDefinition.messageBody;
        if(mailBody.indexOf("~EMAIL_SUFFIX~") != -1) {
			if(this.messageSuffix) {
				let mailSuffix = this.parseMessageBody(this.messageSuffix.messageSuffix);
				mailBody = mailBody.replaceAll("~EMAIL_SUFFIX~", mailSuffix);
			} else {
				mailBody = mailBody.replaceAll("~EMAIL_SUFFIX~", "");
			}
		}
        
        mailOpt.text = this.parseMessageBody(mailBody);
        mailOpt.subject = this.autoMessageDefinition.subject;
        if(this.agency && this.agency.id && !Settings.getInstance().isEmailOptoutAgency(this.agency.id)) {
        	mailOpt.cc = this.agency.emailAddress;
        	/** if there is a secondary email address, add them in on the to cc line. **/
        	if(this.agency.emailAddressSecondary) {
        		mailOpt.cc += ';'+this.agency.emailAddressSecondary;
        	}
        }
        mailOpt.to = this.case.email;
        /** if there is an advocate, add them in on the to line. **/
        if(this.case.advocateEmail !== undefined) {
            mailOpt.to += ';'+this.case.advocateEmail;
        }

        /** note 'from' address is set in the server **/

        this.messagesService.sendMessage(mailOpt). subscribe(
            (result) => {
                /** done **/
                let msgSent = new MessagesSent();
                msgSent.setMessageSent(this.serviceRequest.caseId, this.autoMessageDefinition.id, this.agency?.id || 0, this.agency?.agencyName || '');
                if(this.evCode == 'MANUAL_MATCH_RENEW' || this.evCode == 'MANUAL_MATCH_NEW' || this.autoMessageDefinition.messageCategory == 'Request' 
                	|| (this.serviceRequest != null && this.serviceRequest != undefined && this.serviceRequest.id > 0)) {
                	msgSent.foreignKeyTable = 'ServiceRequests';
                	msgSent.foreignKeyId = this.serviceRequest.id;
                }
                msgSent.sentTo = mailOpt.to.toString();
                msgSent.sentCc = mailOpt.cc.toString();
                msgSent.sentBy = 'system'
                msgSent.subject = mailOpt.subject;
                msgSent.messageBody = mailOpt.text;

                this.messagesService.createMessageSent(msgSent).subscribe(
                    (result2) => {
                        this.messageSentSuccessEv.emit();
                    },
                    (error) => {
                        Settings.getInstance().handleError(error, 'creating messages sent');
                        this.messageSentFailureEv.emit();
                    }
                )
            },
            (error) => {
                Settings.getInstance().handleError(error,'sending mail message');
                this.messageSentFailureEv.emit();
            });

    }
}
